// extracted by mini-css-extract-plugin
module.exports = {"recentWrap":"AWHo-ucqaKyNkBCFuQyg0"};